// src/pages/RedirectFundingGuide.js
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";

// Whitelist of valid programmatic guide slugs to block crawler traps
const VALID_COUNTRIES = [
  "south-africa", "nigeria", "kenya", "egypt", "ghana", 
  "angola", "morocco", "rwanda", "uganda", "tanzania", 
  "senegal", "zimbabwe", "namibia", "botswana", "mozambique", 
  "mali", "libya", "algeria", "burundi", "lesotho", "zambia", "drc"
];

const RedirectFundingGuide = () => {
  const { country } = useParams();

  // Normalize incoming route parameter string safely
  const structuralSlug = country ? country.toLowerCase().trim() : "";

  // Guard Clause: If the country code is invalid, break loop safely to trigger 404
  if (!VALID_COUNTRIES.includes(structuralSlug)) {
    return <Navigate to="/404" replace />;
  }

  // Construct target deterministic blog canonical path
  const targetUrl = `/blog/${structuralSlug}-funding-guide`;
  const absoluteCanonicalUrl = `https://investorlanes.com${targetUrl}`;

  return (
    <>
      <Helmet>
        {/* Modern SEO instruction for modern crawlers hitting dynamic paths */}
        <title>Redirecting to Alternative Asset Hub...</title>
        <meta name="robots" content="noindex, follow" />
        <meta httpEquiv="refresh" content={`0;url=${targetUrl}`} />
        <link rel="canonical" href={absoluteCanonicalUrl} />
      </Helmet>

      {/* Immediate execution client-side state router replacement */}
      <Navigate to={targetUrl} replace />
    </>
  );
};

export default RedirectFundingGuide;
